<template>
  <label class="container">
    <input type="checkbox" v-model="checked" @change="check($event)" />
    <span class="checkmark">
      <svg v-if="checked" viewBox="0 0 26 24">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-141.000000, -602.000000)">
            <g transform="translate(80.000000, 30.000000)">
              <rect fill="#FFFFFF" x="0" y="0" width="1276" height="731"></rect>
              <g
                transform="translate(10.000000, 380.000000)"
                fill="#EFEFEF"
                stroke="#808080"
              >
                <rect id="bg" x="0.5" y="0.5" width="1255" height="239"></rect>
              </g>
            </g>
            <g id="Check-box" transform="translate(136.000000, 597.000000)">
              <rect
                id="bg"
                stroke="#707070"
                stroke-width="2"
                fill="#FFFFFF"
                x="1"
                y="1"
                width="35"
                height="33"
              ></rect>
              <polygon
                id="tick"
                fill="#000000"
                points="26.9351443 5.76112109 30.3801676 8.43972285 17.399087 28.7152983 5.89288019 18.6345447 8.50630007 15.4734901 16.4523467 22.5518696"
              ></polygon>
            </g>
          </g>
        </g>
      </svg>
    </span>
    <svg
      class="checkbox-svg"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 100 10"
    >
      <text x="1" y="5.5" font-size="4">Allow target MAP &lt; 65 mmHg</text>
    </svg>
  </label>
</template>

<script>
export default {
  name: 'SquareRadioButton',
  data() {
    return {
      checked: false
    }
  },
  props: ['value'],
  methods: {
    check() {
      this.$emit('check', this.checked)
    }
  }
}
</script>

<style scoped>
/* The container */
.container {
  text-align: left;
  display: block;
  position: relative;
  padding-left: 6%;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0.5em;
  left: 0.5em;
  height: 1em;
  width: 1em;
  background-color: white;
  border: solid 2px #707070;
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: white;
  border: solid 2px #707070;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-svg {
  height: 100%;
  width: 100%;
  overflow: visible;
}
</style>
